// extracted by mini-css-extract-plugin
export default {"empty":"empty--dc6cf5ac"};